// extracted by mini-css-extract-plugin
export default {"button":"smart-assistant-topbar-btn_button__Mzlih","icon":"smart-assistant-topbar-btn_icon__fM9Md"};